<template>
<div class="logo-line">
  <img
    class="logo-el-login"
    src="../../assets/images/pages/login/logo_m.png" alt="">
  <el-divider
    class="el-divider-el hidden-sm-and-up"
    color="#000000"
    direction="vertical"
  ></el-divider>
  <span class="logo-r-text mobile-title">
    策略管理系统
  </span>
</div>
</template>

<script>
export default {
  name: "logoLine"
}
</script>

<style lang="scss" scoped>
.logo-line {
  display: flex;
  justify-content: start;
  align-items: center;
  .logo-el-login {
    height: 27px;
  }
  font-size: 16px;
  color: #000000;
  /deep/ .el-divider {
    background-color: #000000;
  }
}
</style>
<style lang="scss">
//pc端
@media screen and (min-width: 768px) {
  .mobile-cpt {
    display: none;
  }
  .mobile-title {
    display: none;
  }
  .el-divider-el {
    display: none;
  }
}
//移动端
@media screen and (max-width: 768px){
  .pc-cpt {
    display: none;
  }
  .pc-title {
    display: none;
  }
}
</style>
